import {createAsyncThunk ,  createSlice} from "@reduxjs/toolkit";
import axios from "axios";
import {baseUrl , config} from "../../utils/baseUrl"

export const registerUserAction = createAsyncThunk("user/register" , async(user,{rejectWithValue , getState , dispatch})=>{
    try {
        const sendData = {
            "name" : user.name,
            "password" : user.password,
            "email" : user.email,
            "collegeName" : user.collegename,
        }

        const {data} = await axios.post(`${baseUrl}/api/user/register`,sendData,config);
        console.log(data);
        localStorage.setItem("userInfo",JSON.stringify(data.createdUser));
        localStorage.setItem("token",JSON.stringify(data.Token));

        return data;
        
    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});


export const loginUserAction = createAsyncThunk("user/login",async(user,{rejectWithValue,getState,dispatch})=>{
    try {
        const sendData = {
            email : user.email,
            password : user.password,
        }

        const {data} = await axios.post(`${baseUrl}/api/user/login`,sendData,config);

        localStorage.setItem("userInfo",JSON.stringify(data?.updatedUser));
        localStorage.setItem("token",JSON.stringify(data?.Token));

        return data;


    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});

export const userDetailAction = createAsyncThunk("user/details",async(user,{rejectWithValue,getState,dispatch})=>{
    try {
        const sendData = {
            token : localStorage.getItem("token")
        }

        // console.log(localStorage.getItem("token"));
        const {data} = await axios.post(`${baseUrl}/api/user/details`,sendData,config);
        localStorage.setItem("userInfo",JSON.stringify(data?.userDetails));

        // console.log(data.userDetails);
        return data;
    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});

export const leaderboardAction = createAsyncThunk("leaderBoard/details",async(user,{rejectWithValue,getState,dispatch})=>{
    try {
        const sendData = {
            token : localStorage.getItem("token"),
        }

        const {data} = await axios.post(`${baseUrl}/api/user/leaderBoard`,sendData,config);

        return data;

    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});


export const updateDetailsAction = createAsyncThunk("user/updateDetails",async(user,{rejectWithValue,getState,dispatch})=>{
    try {
        const sendData = {
            name : user.name,
            college : user.collegeName,
            profilePic : user.profilePic,
            token : localStorage.getItem("token"),
        }

        const {data} = await axios.put(`${baseUrl}/api/user/updateDetails`,sendData,config);
      
        return data;
    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});

export const updatedPasswordAction = createAsyncThunk("user/updatePassord",async(user,{rejectWithValue,getState,dispatch})=>{
    try {
        const sendData = {
            newPassword : user.newPassword,
            oldPassword : user.oldPassword,
            token : localStorage.getItem("token"),
        }

        const {data} = await axios.put(`${baseUrl}/api/user/updatePassword`,sendData,config);

        return data;
    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});



export const resetPasswordEmailSendAction = createAsyncThunk("password/sendMail",async(payload,{rejectWithValue,getState,dispatch})=>{
    try {
        const sendData = {
            email : payload?.email,
        }

        const {data} = await axios.post(`${baseUrl}/api/user/resetPasswordlink`,sendData,config);

        return data;
    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});


export const resetPasswordAction = createAsyncThunk("password/resetPassword",async(payload,{rejectWithValue,getState,dispatch})=>{
    try {
        const sendData = {
            password : payload?.password,
            token : payload?.token,
        }

        const {data} = await axios.put(`${baseUrl}/api/user/resetPassword`,sendData,config);

        return data;
    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});



export const logoutUserAction = createAsyncThunk("user/logout",async(user,{rejectWithValue,getState,dispatch})=>{
    try {
        localStorage.removeItem("userInfo");
        localStorage.removeItem("token");
    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});

export const deleteUserAction = createAsyncThunk("user/delete",async(user,{rejectWithValue,getState,dispatch})=>{
    try {
        const sendData = {
            token : localStorage.getItem("token"),
            userId : user.id,
        }

        const {data} = await axios.put(`${baseUrl}/api/user/delete`,sendData,config);

        return data;
    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});

export const usermessageDeleteAction = createAsyncThunk('message/delete',async(payload,{rejectWithValue,getState,dispatch})=>{
    try {
        // Delete message;
    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});

export const changePrevLinkAction = createAsyncThunk('change/prevLink',async(payload,{rejectWithValue,getState,dispatch})=>{
    try {
        return payload;
    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});


//get ser from localState
let userAuth;

const userInfo = localStorage.getItem("userInfo");

if(userInfo || userInfo !== undefined){
    try {
        userAuth = JSON.parse(userInfo);
    } catch (error) {
        console.error("Failed to parse userInfo",error);
        userAuth = null;
    }
}else{
    userAuth = null;
}

const userSlice = createSlice({
    name : "user",
    initialState : {
        user : userAuth,
        prevLink : "/", 
    },

    extraReducers : (builder)=>{

        //register 
        builder.addCase(registerUserAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(registerUserAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.user = action?.payload?.createdUser;
            state.appError = undefined;
            state.serveError = undefined;
        });
        builder.addCase(registerUserAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError = action?.payload?.message;
            state.serveError = action?.payload?.message;
        });

        //login
        builder.addCase(loginUserAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(loginUserAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.user = action?.payload?.updatedUser;
            state.appError = undefined;
            state.serveError = undefined;
        });
        builder.addCase(loginUserAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError = action?.payload?.message;
            state.serveError = action?.payload?.message;
        });

        //logout
        builder.addCase(logoutUserAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(logoutUserAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.user = null;
            state.appError = undefined;
            state.serveError = undefined;
        });
        builder.addCase(logoutUserAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError = action?.payload?.message;
            state.serveError = action?.payload?.message;
        });


        //details
        builder.addCase(userDetailAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(userDetailAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.user = action?.payload?.userDetails;
            state.appError = undefined;
            state.serveError = undefined;
        });
        builder.addCase(userDetailAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError =action?.payload?.message;
            state.serveError = action?.payload?.message;
        });

        //updated details
        builder.addCase(updateDetailsAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(updateDetailsAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.user = action?.payload?.updatedUser;
            state.appError = undefined;
            state.serveError = undefined;
        });
        builder.addCase(updateDetailsAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError =action?.payload?.message;
            state.serveError = action?.payload?.message;
        });
        
        //updatedPassword
        builder.addCase(updatedPasswordAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(updatedPasswordAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.appError = undefined;
            state.serveError = undefined;
        });
        builder.addCase(updatedPasswordAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError =action?.payload?.message;
            state.serveError = action?.payload?.message;
        });
        
       

        //leader board
        builder.addCase(leaderboardAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(leaderboardAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.leaderBoard = action?.payload?.users;
            state.rank = action?.payload?.rank;
            state.appError = null;
            state.serveError = null;
        });
        builder.addCase(leaderboardAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError = action?.payload?.message;
            state.serveError = action?.payload?.message;
        });

        //send mail for reset password 
        builder.addCase(resetPasswordEmailSendAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(resetPasswordEmailSendAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.message = action?.payload?.message;
            state.appError = null;
            state.serveError = null;
        });
        builder.addCase(resetPasswordEmailSendAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError = action?.payload?.message;
            state.serveError = action?.payload?.message;
        });

        //reset password 
        builder.addCase(resetPasswordAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(resetPasswordAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.message = action?.payload?.message;
            state.appError = null;
            state.serveError = null;
        });
        builder.addCase(resetPasswordAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError = action?.payload?.message;
            state.serveError = action?.payload?.message;
        });

        //delete user
        builder.addCase(deleteUserAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(deleteUserAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.message = action?.payload?.message;
            state.appError = null;
            state.serveError = null;
        });
        builder.addCase(deleteUserAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError = action?.payload?.message;
            state.serveError = action?.payload?.message;
        });


        //delete message
        builder.addCase(usermessageDeleteAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(usermessageDeleteAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.message = null;
            state.appError = null;
            state.serveError = null;
        });
        builder.addCase(usermessageDeleteAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError = null;
            state.serveError = null;
        });

        //change prev link
        builder.addCase(changePrevLinkAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(changePrevLinkAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.prevLink = action?.payload?.prevLink;
            state.appError = null;
            state.serveError = null;
        });
        builder.addCase(changePrevLinkAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError = null;
            state.serveError = null;
        });
    }
})

export default userSlice.reducer;